export default "__VITE_ASSET__CpliqFVy__"